import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import {
  adaptLAreasToStore
} from './adapters/lareaAdapter'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listLAreas',
    method: 'get',
    url: (params) => `/learning-areas${buildParamList(params)}`,
    resolver: adaptLAreasToStore
  },
  {
    name: 'getLArea',
    method: 'get',
    url: (params) => `/learning-areas/${params.lareaId}`
  }
]

export const {
  listLAreas,
  getLArea
} = buildServices(CONTENT, services)